@if (isFramed) {
  <header class="modal__header">
    <h2 class="modal__title">{{ title }}</h2>

    <button class="modal__close" type="button" aria-label="Fechar" (click)="close()">
      <i class="cds-icon-close" aria-hidden="true"></i>
    </button>
  </header>
} @else if (needsFloatingClose) {
  <!--
    F1: the "X" for a package filter modal that brings its own card and no button. It
    floats over that card, in the corner, instead of adding a header the package does
    not draw.
  -->
  <button class="modal__close modal__close--floating" type="button" aria-label="Fechar" (click)="close()">
    <i class="cds-icon-close" aria-hidden="true"></i>
  </button>
}

<div class="modal__content">
  @if (contentAsComponent) {
    <ng-container *ngComponentOutlet="contentAsComponent" />
  } @else if (contentAsTemplate) {
    <ng-container *ngTemplateOutlet="contentAsTemplate" />
  } @else if (contentAsText) {
    <p>{{ contentAsText }}</p>
  }
</div>
